import { Injectable, computed, signal } from '@angular/core';
import { OverlayConfig } from '@shared/models/overlay.models';

@Injectable({
  providedIn: 'root',
})
export class OverlayHandler {
  private readonly dialogConfig = signal<OverlayConfig | null>(null);
  public readonly dialog = computed(() => this.dialogConfig());

  public showOverlay(config: OverlayConfig) {
    // this needs to be set like this because otherwise the reference is the same as before and the dialog
    // will not open
    this.dialogConfig.set({ ...config });
  }

  public hideOverlay() {
    this.dialogConfig.set(null);
  }
}
